// extracted by mini-css-extract-plugin
module.exports = {"content":"BaseLayout_content__G7i4h"};